/**
 * Type predicate to handle discriminating between REST and GraphQL data.
 */
export default function isGraphQL(data?: {__typename?: string; id: string}): data is {
  __typename: string;
  id: string;
} {
  return data?.__typename != null;
}
